module.exports = __webpack_public_path__ + "static/media/banners.4797f203.svg";